/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const quickProductLookupUri = "/api/sainc/myAccount";

export interface QuickProductLookup {
    productNumber: string;
    productDescription: string;
    manufacturerSalePrice: number;
    manufacturerSalePriceDisplay: string;
    discountPercent: number;
    discountPercentDisplay: string;
    discountPrice: number;
    discountPriceDisplay: string;
    availability: string;
    hasComponents: boolean;
    availableQty: number;
    billOfMaterials: BillOfMaterial[] | null;
    url?: string;
    urlIsSet?: boolean;
    productId?: string;
    trackInventory?: boolean;
    unitOfMeasure?: string;
}

export interface ProductPartList extends QuickProductLookup {
    parentProductNumber: string;
    qtyPer: number;
}

export interface QuickProductLookupModel extends BaseModel {
    dealerPrices: QuickProductLookup[];
}

export interface ProductPartListModel extends BaseModel {
    dealerComponentPrices: ProductPartList[];
}

export interface BillOfMaterial {
    parentPartNumber: string;
    partNumber: string;
    qtyPer: number;
    uom: string;
    description: string;
}

export async function getQuickProductLookup() {
    try {
        const result = await get<QuickProductLookupModel>(`${quickProductLookupUri}/dealerPrices`);
        return {
            successful: true,
            products: result,
        };
    } catch (error) {
        return {
            successful: false,
            products: null,
            error: (error as any).message,
        };
    }
}

export interface ProductComponentsProps extends ApiParameter {
    productNumber: string;
}

export async function getProductComponentList(props: ProductComponentsProps) {
    try {
        const result = await get<ProductPartListModel>(
            `${quickProductLookupUri}/dealerComponentPrices?productNumbers=${props.productNumber}`,
        );
        return {
            successful: true,
            partLists: result,
        };
    } catch (error) {
        return {
            successful: false,
            partLists: null,
            error: (error as any).message,
        };
    }
}
